import en from './en.json'
import it from './it.json'

export const residencesTranslations = {
	en,
	it
} as const
